import { render, staticRenderFns } from "./ITSkills.vue?vue&type=template&id=491bbbb9&scoped=true&"
import script from "./ITSkills.vue?vue&type=script&lang=ts&"
export * from "./ITSkills.vue?vue&type=script&lang=ts&"
import style0 from "./ITSkills.vue?vue&type=style&index=0&id=491bbbb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491bbbb9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCard,VCardText,VCardTitle,VProgressCircular})
